export function calculatePercentage (value1, value2, numberAfterDecimal) {
  // Security if one of values is negative or undefined or NaN
  if (
    isNaN(value1) ||
    isNaN(value2) ||
    !value1 ||
    !value2 ||
    value1 < 0 ||
    value2 < 0
  ) {
    return 0
  }
  try {
    const percentage = (value1 / value2) * 100
    if ((percentage - Math.floor(percentage)) !== 0) {
      return Number((percentage).toFixed(numberAfterDecimal))
    }
    return percentage
  } catch (err) {
    console.log('Problem with calculatePercentage')
    console.log(err)
    return 0
  }
}



// WEBPACK FOOTER //
// ./src/helpers/calculatePercentage.js